module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeAQMAAAAB/jzhAAAABlBMVEUAAAC/v79T5hyIAAAAAXRSTlMAQObYZgAAABdJREFUCNdj+P///x8IcYCBgWdACYRbANZeJJ1bHVkzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/btn-select.png
// module id = 524
// module chunks = 0